/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResetPasswordRequest {
    getFixupPrototypeFunction() { return ResetPasswordRequest.fixupPrototype; }

    static newInstance(model: Partial<ResetPasswordRequest>): ResetPasswordRequest {
        let obj = Object.assign(new ResetPasswordRequest(), model);
        ResetPasswordRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResetPasswordRequest>): ResetPasswordRequest {
        if (!model) return null;
        return ResetPasswordRequest.newInstance(<ResetPasswordRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResetPasswordRequest) {
        if (!obj) return;

        models.ResetPasswordRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResetPasswordRequest): boolean {
        Object.setPrototypeOf(obj, ResetPasswordRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * User email id.
     */
    email_id: string;

    /**
     * Please Provide the URl
     */
    url: string;

}
